import * as Scrivito from "scrivito";
import metadataAttributes from "objs/_metadataAttributes";

const Locals = Scrivito.provideObjClass("Locals", {
  attributes: {
    title: "string",
    localsAE: "string",
    localsFJ: "string",
    localsKO: "string",
    localsPT: "string",
    localsUZ: "string",
    ...metadataAttributes,
  },
  extractTextAttributes: ["title"],
});

export default Locals;
